export const asStates = [{ value: 'AS', label: 'AS' }]
